import { render } from "./Sony.vue?vue&type=template&id=99c6d094&scoped=true"
import script from "./Sony.vue?vue&type=script&lang=js"
export * from "./Sony.vue?vue&type=script&lang=js"

import "./Sony.vue?vue&type=style&index=0&id=99c6d094&lang=scss&scoped=true"

import exportComponent from "E:\\Old Files\\Projecten Web\\Q-Mobile\\frame\\q-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99c6d094"]])

export default __exports__